import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { SvgIconComponent, injectRegisterIcons } from '@ngneat/svg-icon';
import { TranslatePipe } from '@ngx-translate/core';

import {
  AiAssistantUiContext,
  AiAssistantUiContextKey,
  buildAiAssistantUiContextItems,
} from '@domain/ai-assistant/ai-assistant-ui-context';

import { appCloseV224Icon } from '@icons/close-v2-24';

@Component({
  selector: 'app-ai-ui-context-box',
  templateUrl: './ai-ui-context-box.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe, SvgIconComponent],
  host: {
    class: 'flex flex-col',
    '[class.hidden]': 'items().length === 0',
  },
})
export class AiUiContextBoxComponent {
  public context = input<AiAssistantUiContext | undefined>();
  public removable = input(false);
  public removed = output<AiAssistantUiContextKey>();
  public readonly items = computed(() => buildAiAssistantUiContextItems(this.context()));

  constructor() {
    injectRegisterIcons([appCloseV224Icon]);
  }
}
